import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useRouteTransition } from '../../nav/RouteTransition';

/**
 * OPENING A RECORD FROM THE LIST, IN ONE PLACE (wave 3, L-B1).
 *
 * The list has four ways to promote a row to the record page - a double click, Enter on the
 * focused row, the row menu's Open, and the detail pane's Open - and until this hook existed
 * two of them were a `TransitionLink` (animated push) while the third called `navigate`
 * directly (no animation), which is two answers to one question. The screen now has one.
 *
 * The PUSH direction is the row's relation to the record: the list is above it in the
 * hierarchy, so the record slides in from the trailing edge the way a pushed screen does
 * (`app/nav/RouteTransition`, and rulebook N8 for the way back).
 */
export function useOpenRecord(objectId: string): (recordId: string) => void {
  const run = useRouteTransition();
  const navigate = useNavigate();

  return useCallback(
    (recordId: string) => {
      run('push', () => {
        void navigate(`/objects/${objectId}/records/${recordId}`);
      });
    },
    [objectId, navigate, run],
  );
}
